module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0074.jpg?v=56c21f6c";